// extracted by mini-css-extract-plugin
module.exports = {"reportFraud":"ReportFraudIcon__reportFraud___2lMYC","stroked":"ReportFraudIcon__stroked___6njqA","filled":"ReportFraudIcon__filled___35sq-"};